import { config, library, dom } from "@fortawesome/fontawesome-svg-core"
import {
  faAnglesLeft,
  faArrowUpRightFromSquare,
  faCircleHalfStroke,
  faCircleInfo,
  faCircleXmark,
  faCopy,
  faDownload,
  faFileExport,
  faPencil
} from "@fortawesome/free-solid-svg-icons"

config.mutateApproach = "sync"
library.add(
  faAnglesLeft,
  faArrowUpRightFromSquare,
  faCircleHalfStroke,
  faCircleInfo,
  faCircleXmark,
  faCopy,
  faDownload,
  faFileExport,
  faPencil
)
dom.watch()
